import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TexteService } from 'src/app/core/services/texte.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IAllergie } from 'src/app/core/interfaces/allergie.interface';

@Component({
    selector: 'app-allergie-form',
    templateUrl: './allergie-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AllergieFormComponent implements OnInit {

  public allergieForm: FormGroup;

  constructor(
    public texteService: TexteService
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm() {
    this.allergieForm = new FormGroup({
      allergie: new FormControl('', Validators.required),
      precision: new FormControl(''),
      listeMedicament: new FormControl(''),
    });
  }

  public isValid(): boolean {
    return this.allergieForm.valid;
  }

  public getForm(): IAllergie {
    return {
      allergie: this.allergieForm.get('allergie').value,
      precision: this.allergieForm.get('allergie').value === 'true' ? this.allergieForm.get('precision').value : null,
      listeMedicament: this.allergieForm.get('listeMedicament').value,
    } as IAllergie;
  }
}
